module.exports = __webpack_public_path__ + "img/casque.c78d404d.jpg";